import { render, staticRenderFns } from "./listaUsuarios.vue?vue&type=template&id=20d7158a"
import script from "./listaUsuarios.vue?vue&type=script&lang=js"
export * from "./listaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./listaUsuarios.vue?vue&type=style&index=0&id=20d7158a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports